import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import { useUserContext } from '@/contexts/user';
import { ChargeType } from '@/modelTypes';
import { creditCardSelector } from '@/selectors/creditCardBrand';

import { ResultText, Wrapper } from './style';

interface QuickChargeSuccessProps {
  chargeType: ChargeType;
  handleClose: () => void;
}

const QuickChargeSuccess: React.FC<QuickChargeSuccessProps> = ({
  chargeType,
  handleClose,
}) => {
  const { user } = useUserContext();
  const { isPcc } = creditCardSelector(user.creditCard);

  return (
    <Wrapper>
      <ResultText>
        {isPcc || chargeType === ChargeType.Wallet ? (
          <>toreta+ チャージが完了しました。</>
        ) : (
          <>
            ちょコムクレジット支払いでちょコムeマネーのチャージを行い、
            <br />
            ちょコムeマネーからtoreta+ チャージが完了しました。
          </>
        )}
      </ResultText>
      <Button
        bgColor="primary"
        size={['s', 's', 'm', 'm']}
        width="160px"
        height="56px"
        fontWeight="bold"
        outline
        radius="l"
        onClick={() => handleClose()}
      >
        閉じる
      </Button>
    </Wrapper>
  );
};

export default QuickChargeSuccess;
